import { Component } from '@angular/core';
import { NavParams } from 'ionic-angular';
import { SessionProvider } from '../../providers/session/session';
@Component({
    templateUrl: 'participant-page.html',
    selector: 'participant-page'
  })

  export class ParticipantPage {
      selectedSegment: string = "participant";
      athlete: boolean = false;
      team: any = {
        name: ''
      };
      selectedParticipant: string ='team-select';

      constructor(
        public sessionService: SessionProvider,
        private navParams: NavParams){
          this.team = navParams.get('team') || this.team;
        }

      public isLoged(): boolean {
        console.log("LOGED" + this.sessionService.isLoged);
        return this.sessionService.isLoged;
      }
  }


// WEBPACK FOOTER //
// /src/pages/participant-page/participant-page.ts